import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminPanel from "./Components/AdminComp/AdminPanel";
import Login from "./Components/LoginComp/Login";
import ForgotPassword from "./Components/LoginComp/ForgotPassword";
import Consultant from "./Components/AdminComp/Consultant";
import { auth, db } from "./Components/LoginComp/firebase";
import PrivateRoute from "./PrivateRoute";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { ToastContainer } from "react-toastify";




const App = () => {
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          setUserRole(userDoc.data().role);
        }
      } else {
        setUserRole(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <Router>
           <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/ForgotPassword" element={<ForgotPassword/>} />
       
   
        <Route
          path="/AdminPanel"
          element={
            <PrivateRoute role="admin" userRole={userRole}>
              <AdminPanel />
            </PrivateRoute>
          }
        />


        <Route
          path="/Consultant"
          element={
            <PrivateRoute role="consultant" userRole={userRole}>
              <Consultant />
            </PrivateRoute>
          }
        />





      </Routes>
   
    </Router>

    
  );
};

export default App;
